import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Button extends PureComponent {
  render() {
    const { children, className, type, disabled, loading, mini, vcode, ...others } = this.props;
    const typeStr = type || "default";
    const cls = classNames({
      "weui-btn": true,
      [`weui-btn_${typeStr}`]: true,
      "weui-btn_disabled": disabled,
      "weui-btn_loading": loading,
      "weui-btn_mini": mini,
      "weui-cell_control": vcode,
      "weui-vcode-btn": vcode
    }, className);

    return (
      <button className={ cls } disabled={ disabled } { ...others }>
        {
          loading && <span className="weui-primary-loading">
            <i className="weui-primary-loading_dot"></i>
          </span>
        }
        { children }
      </button>
    );
  }
}
